// extracted by mini-css-extract-plugin
export default {"button":"GoogleLogin_button__v+wlB"};